import React from 'react';
import { Link } from 'react-router-dom';
import '../../css/legal.css';

const PrivacyPolicy = () => (
    <div className="tamcare-legal-page">
        <div className="tamcare-legal-shell">
            <h1>Chính sách bảo mật</h1>
            <p className="tamcare-legal-updated">Cập nhật: 21/06/2026</p>

            <section>
                <h2>1. Giới thiệu</h2>
                <p>
                    TamCare (“chúng tôi”) cung cấp website và ứng dụng di động giúp người dùng{' '}
                    <strong>ghi chép, lưu trữ và xem lại thông tin cá nhân</strong> liên quan đến sinh hoạt
                    hàng ngày (nhắc uống thuốc, điểm danh, chỉ số tự đo) và kết nối với người thân đã được
                    mời liên kết.
                </p>
                <p>
                    TamCare <strong>không phải</strong> cơ sở y tế, không phải thiết bị y tế và{' '}
                    <strong>không cung cấp</strong> dịch vụ khám, chẩn đoán, kê đơn hay điều trị.
                    Chính sách này mô tả cách chúng tôi thu thập, sử dụng và bảo vệ dữ liệu của bạn.
                </p>
            </section>

            <section>
                <h2>2. Bản chất dịch vụ (quan trọng)</h2>
                <p>Để tránh hiểu nhầm, TamCare được thiết kế như một <strong>công cụ số cá nhân</strong>:</p>
                <ul>
                    <li>
                        <strong>Lưu trữ thông tin:</strong> bạn (hoặc người thân được ủy quyền) tự nhập và lưu
                        chỉ số, ghi chú, lịch thuốc, tài liệu bạn muốn theo dõi.
                    </li>
                    <li>
                        <strong>Hiển thị dễ hiểu:</strong> biểu đồ, danh sách, lịch nhắc giúp bạn xem lại dữ
                        liệu đã nhập theo thời gian.
                    </li>
                    <li>
                        <strong>Gợi ý tham khảo (không bắt buộc):</strong> một số tính năng AI có thể đưa ra
                        câu trả lời hoặc gợi ý chung dựa trên dữ liệu bạn cung cấp — chỉ để{' '}
                        <strong>tham khảo</strong>, không phải quyết định y khoa.
                    </li>
                </ul>
                <p>
                    Việc bạn sử dụng TamCare <strong>không thay thế</strong> việc thăm khám, xét nghiệm hoặc
                    tuân thủ chỉ định của bác sĩ.
                </p>
            </section>

            <section>
                <h2>3. Dữ liệu chúng tôi thu thập</h2>
                <ul>
                    <li>
                        <strong>Tài khoản:</strong> tên đăng nhập, họ tên, mật khẩu (đã mã hóa), email; số
                        điện thoại <strong>(tùy chọn, không bắt buộc khi đăng ký)</strong>.
                    </li>
                    <li>
                        <strong>Chỉ số do người dùng tự nhập:</strong> huyết áp, nhịp tim, đường huyết, nhiệt
                        độ, cân nặng và ghi chú kèm theo — dùng để <strong>lưu trữ và hiển thị biểu đồ</strong>,
                        không phải đo tự động từ thiết bị y tế chứng nhận.
                    </li>
                    <li>
                        <strong>Hồ sơ / tài liệu cá nhân:</strong> thông tin bạn tự tải lên hoặc ghi (ví dụ:
                        lời dặn bác sĩ, lịch tái khám, danh sách thuốc) để tiện tra cứu.
                    </li>
                    <li>
                        <strong>Nhắc nhở &amp; hoạt động:</strong> lịch uống thuốc, điểm danh hàng ngày, thông
                        báo nhắc việc.
                    </li>
                    <li>
                        <strong>Trợ lý AI (chat):</strong> nội dung tin nhắn và ảnh bạn <strong>chủ động gửi</strong>{' '}
                        khi sử dụng tính năng chat — được lưu để bạn xem lại lịch sử hội thoại.
                    </li>
                    <li>
                        <strong>Phân tích tham khảo (AI engine):</strong> khi bật, hệ thống có thể xử lý chỉ số
                        bạn đã nhập để tạo <strong>gợi ý chung</strong> (ví dụ: nhắc theo dõi thêm, gợi ý sinh
                        hoạt). Kết quả <strong>không phải chẩn đoán</strong> và không kê đơn thuốc.
                    </li>
                    <li>
                        <strong>Thiết bị:</strong> token push notification (FCM) để gửi nhắc nhở (nếu bạn cho
                        phép).
                    </li>
                </ul>
            </section>

            <section>
                <h2>4. Chi tiết tính năng dễ gây hiểu nhầm</h2>

                <h3>4.1. Trợ lý AI (ChatBox)</h3>
                <ul>
                    <li>Chat AI trả lời dựa trên mô hình ngôn ngữ và ngữ cảnh bạn cung cấp.</li>
                    <li>
                        Mục đích: hỗ trợ <strong>tra cứu thông tin sức khỏe phổ thông</strong> và gợi ý mang
                        tính tham khảo.
                    </li>
                    <li>
                        <strong>Không phải:</strong> bác sĩ, điều dưỡng, tư vấn y tế chuyên môn hay dịch vụ
                        cấp cứu.
                    </li>
                    <li>
                        Mọi câu trả lời đều kèm cảnh báo; bạn không nên dùng kết quả chat làm cơ sở duy nhất
                        để thay đổi thuốc, chế độ ăn hoặc quyết định điều trị.
                    </li>
                    <li>
                        Tin nhắn chat được lưu trên máy chủ của chúng tôi để đồng bộ giữa các thiết bị đã
                        đăng nhập; bạn có thể xóa tài khoản để yêu cầu xóa dữ liệu theo mục 8.
                    </li>
                </ul>

                <h3>4.2. Nhập chỉ số &amp; biểu đồ</h3>
                <ul>
                    <li>Chỉ số do <strong>bạn tự nhập thủ công</strong> hoặc từ nguồn bạn chọn.</li>
                    <li>
                        TamCare <strong>không xác minh</strong> độ chính xác y khoa của dữ liệu nhập tay và
                        không đưa ra chẩn đoán từ một lần đo.
                    </li>
                    <li>Biểu đồ chỉ giúp bạn và người thân đã liên kết <strong>quan sát xu hướng</strong> theo
                        thời gian.
                    </li>
                </ul>

                <h3>4.3. Gợi ý / cảnh báo từ AI engine</h3>
                <ul>
                    <li>
                        Nếu có, thông báo hoặc gợi ý chỉ mang tính <strong>nhắc nhở tham khảo</strong> (ví
                        dụ: “nên theo dõi thêm”, “cân nhắc liên hệ bác sĩ”).
                    </li>
                    <li>
                        Đây <strong>không phải</strong> hệ thống giám sát y tế liên tục hay báo động cấp cứu
                        chuyên nghiệp.
                    </li>
                    <li>Khi có dấu hiệu nguy hiểm, hãy gọi <strong>115</strong> hoặc đến cơ sở y tế.</li>
                </ul>

                <h3>4.4. Nhắc uống thuốc</h3>
                <ul>
                    <li>Chức năng nhắc lịch do <strong>bạn hoặc người thân tự thiết lập</strong>.</li>
                    <li>TamCare không kê đơn, không điều chỉnh liều lượng thuốc thay bác sĩ.</li>
                </ul>
            </section>

            <section>
                <h2>5. Mục đích sử dụng dữ liệu</h2>
                <ul>
                    <li>Vận hành tài khoản và các tính năng lưu trữ / hiển thị thông tin.</li>
                    <li>Gửi nhắc nhở uống thuốc, tái khám (theo lịch bạn đặt).</li>
                    <li>Cho phép người thân đã liên kết xem dữ liệu bạn đồng ý chia sẻ.</li>
                    <li>Lưu lịch sử chat AI để bạn tra cứu lại trên các thiết bị.</li>
                    <li>Xử lý gợi ý tham khảo từ AI (nếu bạn sử dụng tính năng này).</li>
                    <li>Cải thiện dịch vụ và hỗ trợ kỹ thuật.</li>
                </ul>
                <p>
                    Chúng tôi <strong>không</strong> sử dụng dữ liệu của bạn để cung cấp dịch vụ y tế chuyên
                    môn, không bán dữ liệu cá nhân.
                </p>
            </section>

            <section>
                <h2>6. Chia sẻ dữ liệu</h2>
                <p>
                    Dữ liệu bạn nhập có thể được xem bởi <strong>người thân đã liên kết qua mã kết nối</strong>{' '}
                    do bạn chủ động chia sẻ. Chúng tôi không bán dữ liệu cá nhân. Dữ liệu có thể được lưu/xử lý
                    trên hạ tầng hosting và dịch vụ thông báo (ví dụ Firebase) theo hợp đồng bảo mật.
                </p>
                <p>
                    Nội dung gửi tới trợ lý AI có thể được xử lý qua API của nhà cung cấp mô hình ngôn ngữ
                    (nếu có tích hợp) chỉ nhằm tạo phản hồi tham khảo; chúng tôi không chia sẻ dữ liệu cho mục
                    đích quảng cáo.
                </p>
            </section>

            <section>
                <h2>7. Lưu trữ và bảo mật</h2>
                <p>
                    Dữ liệu được lưu trên máy chủ bảo mật; kết nối production sử dụng HTTPS. Mật khẩu được băm;
                    phiên đăng nhập có thời hạn.
                </p>
            </section>

            <section>
                <h2>8. Quyền của bạn</h2>
                <ul>
                    <li>Xem và cập nhật thông tin cá nhân trong mục Hồ sơ.</li>
                    <li>Bổ sung hoặc không cung cấp số điện thoại khi đăng ký.</li>
                    <li>Yêu cầu xóa tài khoản và dữ liệu liên quan tại <Link to="/account/delete">Xóa tài khoản</Link>.</li>
                    <li>Liên hệ: <a href="mailto:tamcare.contact@gmail.com">tamcare.contact@gmail.com</a></li>
                </ul>
            </section>

            <section>
                <h2>9. Trách nhiệm người dùng</h2>
                <p>
                    Bạn chịu trách nhiệm về tính chính xác của dữ liệu tự nhập và việc sử dụng thông tin trên
                    ứng dụng. Mọi quyết định liên quan sức khỏe quan trọng nên được tham vấn bác sĩ hoặc cơ sở
                    y tế có chức năng.
                </p>
            </section>

            <p className="tamcare-legal-back">
                <Link to="/">← Về trang chủ</Link>
                {' · '}
                <Link to="/terms">Điều khoản sử dụng</Link>
            </p>
        </div>
    </div>
);

export default PrivacyPolicy;
